import { growthBookInstance } from '../../utils/analytics/growthbook';
import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';
import { ABTestReshoppingAlert } from '../../utils/enabled_features/ab_tests';

export const ReshoppingAlertStep: Step = {
  id: 'reshoppingalert',
  pathname: '/reshoppingalert',
  canShow: (appData: AppData): boolean => {
    if (appData.isOnboardingLite || !appData.serviceSplitSelectedService?.insurance) {
      return false;
    }
    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }
    return !!growthBookInstance?.isOn(ABTestReshoppingAlert.storageKey);
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.reshoppingAlertAnswer0,
  category: () => StepCategory.Other,
};
